import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

import { NotificationService } from './../../../Service/notification.service';

import { OtherService } from './../../../Service/other.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { Meta, Title } from '@angular/platform-browser';

import axios from "src/app/Service/axios";


@Component({

  selector: 'app-password-setting',

  templateUrl: './password-setting.component.html',

  styleUrls: ['./password-setting.component.css']

})

export class PasswordSettingComponent implements OnInit {

  pw_OptionsModel: FormGroup = this.formBuilder.group({

    strUserName: new FormControl(this._auth.decrypt(window.localStorage.getItem('5B6Wjog=')!)),

    strPassword: new FormControl(this._auth.decrypt(window.localStorage.getItem('VkX1/o5p')!)),

    tiApplicationSetting: new FormControl(''),

    tiMinPasswordLength: new FormControl('', Validators.required),

    iSessionTimeout: new FormControl('', Validators.required),

    tiMaxWrongLogin: new FormControl('', Validators.required),

    bHasSpecialCharacter: new FormControl(false),

    bHasCapitalLetter: new FormControl(false),

    bLettersAndNumbers: new FormControl(false),

    tiCaptchaLength: new FormControl('', Validators.required),

    tiUserValidityPeriod: new FormControl('', Validators.required),

  })

  webAppName = (<any>window).webAppName;

  constructor(

    private formBuilder: FormBuilder,

    private tooltip: NotificationService,

    private _otherService: OtherService,

    private _auth: GurdServiceService,

    private _title: Title


  ) { }

  ngOnInit(): void {

    this._otherService.setTitle(`${this.webAppName} | تنظیمات امنیتی `);

    // اگر کاربر لاگین نکرده بود

    if (this.pw_OptionsModel.get('strUserName')?.value == '' || this.pw_OptionsModel.get('strPassword')?.value == '') {

      this._otherService.login()

    }

    else {

      this.getAppSettings();

    }

  }

  pwOptions_Update = async () => {

    if (this.pw_OptionsModel.invalid) return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    this._otherService.Showspinner();

    const resp = await axios.post(`ApplicationSetting_Update`, this._otherService.stringNumberToNumber(this.pw_OptionsModel.value));

    this._otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.bError) return this.tooltip.showError(res.strError);

    return this.tooltip.showSuccess('با موفقیت ویرایش شد');

  }

  getAppSettings = async () => {

    this._otherService.Showspinner();

    const resp = await axios.post(`ApplicationSetting_List`, this._otherService.stringNumberToNumber(this.pw_OptionsModel.value));

    this._otherService.nonespinner();

    let res = JSON.parse(resp.data);

    Object.keys(res[0]).forEach((key: any) => {

      this.pw_OptionsModel.get(key)?.setValue(res[0][key])

    })


  }

}
